import React from 'react';
export function BonusSection() {
  const bonuses = [{
    icon: '🗺️',
    title: 'Proveedores Gold Argentina',
    subtitle: 'El Mapa Secreto',
    features: ['Chocolate de cobertura real al mejor precio', 'Mejores moldes de policarbonato del país', 'Colorantes liposolubles y polvos metálicos', 'Packaging premium low cost'],
    value: '$8.000'
  }, {
    icon: '📸',
    title: 'El Celular es tu Cámara',
    subtitle: 'Fotografía Aesthetic $0',
    features: ['Luz natural para brillo explosivo', '3 ángulos que venden cualquier producto', 'Edición rápida con Lightroom Mobile gratis', 'Set de fotos con materiales de librería'],
    value: '$12.000'
  }, {
    icon: '🎨',
    title: 'Paleta de Diseño 2026',
    subtitle: 'Los Colores que Venden',
    features: ['4 paletas tendencia para chocolate aesthetic', 'Psicología del color aplicada al chocolate', 'Combinar texturas para piezas únicas', 'Espacio negativo que encarece tus productos'],
    value: '$7.000'
  }, {
    icon: '💬',
    title: 'Método WhatsApp Gold',
    subtitle: 'Consulta → Pago en 3 Mensajes',
    features: ['Scripts de venta listos para copiar', 'Manejar "es muy caro" sin bajar precio', 'Cierre por escasez que llena tu agenda', 'Estados de WhatsApp como canal de TV'],
    value: '$9.000'
  }];
  return <section className="bg-bonus-gradient py-10 px-5" data-id="element-17">
      <div className="text-center mb-8" data-id="element-18">
        <p className="text-[12px] tracking-[3px] uppercase text-oro-rosa mb-2 font-bold" data-id="element-19">
          🎁 Bonos exclusivos de lanzamiento
        </p>
        <h2 className="font-playfair text-[clamp(22px,3.5vw,36px)] text-blanco mb-2" data-id="element-20">
          Y Además, Recibís Estos 4 Bonos Gratis
        </h2>
        <p className="text-[15px] text-oro-rosa-claro" data-id="element-21">
          Disponibles solo en esta oferta — Valorados en $36.000 ARS
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-[1100px] mx-auto" data-id="element-22">
        {bonuses.map((bonus, index) => <div key={index} className="bg-gradient-bonus rounded-2xl p-5 pt-7 border border-[rgba(212,175,55,0.25)] relative transition-all duration-300 text-center hover:border-dorado hover:-translate-y-1 hover:shadow-[0_15px_30px_rgba(212,175,55,0.15)]" data-id="element-23">
            <div className="absolute top-[-12px] left-1/2 -translate-x-1/2 bg-gradient-gold-rose text-negro py-1 px-3 rounded-full text-[10px] font-bold tracking-[1px] whitespace-nowrap" data-id="element-24">
              BONO {index + 1} — GRATIS
            </div>
            <span className="text-[36px] mb-3 block" data-id="element-25">{bonus.icon}</span>
            <h3 className="font-playfair text-[16px] text-dorado mb-1" data-id="element-26">
              {bonus.title}
            </h3>
            <p className="text-[12px] text-teal mb-3 italic" data-id="element-27">
              {bonus.subtitle}
            </p>
            <ul className="list-none text-left" data-id="element-28">
              {bonus.features.map((feature, i) => <li key={i} className="text-[13px] text-[#cccccc] py-1 border-b border-[rgba(255,255,255,0.05)] flex items-start gap-1.5 last:border-b-0" data-id="element-29">
                  <span className="text-oro-rosa shrink-0 text-[12px]" data-id="element-30">→</span>
                  {feature}
                </li>)}
            </ul>
            <p className="mt-3 text-[12px] text-[#888] line-through" data-id="element-31">
              Valor: {bonus.value}{' '}
              <span className="text-teal font-bold text-[13px] no-underline ml-1" data-id="element-32">
                → GRATIS
              </span>
            </p>
          </div>)}
      </div>
    </section>;
}